import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";
import moment from "moment";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "appeal-call-hearing.component",
  templateUrl: "./appeal-call-hearing.component.html",
  styleUrls: ["./appeal-call-hearing.component.scss"],
})
export class AppealCallHearingComponent implements OnInit {
  hearingCallForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;
  isSubmitDisabled: boolean = false;
  currentDate: Date = new Date();
  minDate: Date;
  constructor(
    private modalCtrl: ModalController,
    private masterService: MasterService,
    private toastController: ToastController
  ) {
    this.minDate = moment(this.currentDate).add(1, "day").toDate();
  }

  ngOnInit(): void {
    this.hearingCallForm = new FormGroup({
      appealRemark: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(3500),
      ]),
      appealHearingDate: new FormControl(null, [
        Validators.required,
        // Validators.minLength(1),
        // Validators.maxLength(100),
      ]),
    });
  }

  handleKeyPress(event: KeyboardEvent): void {
    event.stopPropagation();
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }

  // isCursorAtBeginning(): boolean {
  //   const element = this.appealRemarkTextArea.nativeElement;
  //   return element.selectionStart === 0 && element.selectionEnd === 0;
  // }

  noLeadingSpaceValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value && control.value.trim().length === 0) {
      return { leadingSpace: true }; // Return an error if the value contains only whitespace
    }
    return null; // Return null if the value is valid
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }
  validateAppealHearingDate() {
    return new Date(this.hearingCallForm.value.appealHearingDate) > new Date()
      ? true
      : false;
  }
  approve() {
    if (!this.hearingCallForm.value.appealRemark) {
      this.showErrorToast("Please Enter Approval Remark");
    }
    if (!this.hearingCallForm.value.appealHearingDate) {
      // this.showErrorToast("Please Enter Appeal Hearing Date ");
      this.masterService.errorToast("Please Enter Appeal Hearing Date");
    }
    if (
      !this.validateAppealHearingDate() &&
      this.hearingCallForm.value.appealHearingDate
    ) {
      this.masterService.errorToast(
        "Appeal Hearing Date should be greater than  Current Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (this.hearingCallForm.valid) {
      return this.modalCtrl.dismiss(
        {
          remark: this.hearingCallForm.value.appealRemark,
          appealDate: this.hearingCallForm.value.appealHearingDate,
        },
        "Allowed_For_Hearing"
      );
    } else {
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
